import * as React from 'react';
import { LinkButton } from '@cian/ui-kit/button';
import { Phone16 } from '@cian/ui-kit/icons';

export interface IPhoneButtonProps {
  phone: string;
  text?: string;
}

export const PhoneButton: React.FC<IPhoneButtonProps> = ({ text = 'Позвонить', phone }) => {
  return (
    <LinkButton fullWidth href={`tel:+${phone}`} beforeIcon={<Phone16 color="white_100" />}>
      {text}
    </LinkButton>
  );
};
